<template>
  <div class="w-full">
    <v-chart
      :theme="currentTheme"
      v-loading="chartLoading"
      :options="option"
      autoresize
      class="w-full"
    ></v-chart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'trend-statistics',
  computed: {
    ...mapGetters({ currentTheme: 'System/currentTheme' }),
    option() {
      return {
        color: ['#ff3a30', '#ff9502', '#f8b200', '#0082f7'],
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['重大风险', '较大风险', '一般风险', '低风险'],
        },
        // color: ['#5470c6', '#73c0de', '#91cc75', '#ee6666'],
        grid: {
          left: '4%',
          right: '2%',
          top: '10%',
          bottom: '20%',
        },
        xAxis: [
          {
            type: 'category',
            data: this.values.yearMonth,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            name: '重大风险',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            label: {
              show: true,
              position: 'top',
              fontWeight: 'bold',
            },
            data: this.values.significantRiskCount,
          },
          {
            name: '较大风险',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            label: {
              show: true,
              position: 'top',
              fontWeight: 'bold',
            },
            data: this.values.greaterRiskCount,
          },
          {
            name: '一般风险',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            label: {
              show: true,
              position: 'top',
              fontWeight: 'bold',
            },
            data: this.values.generalRiskCount,
          },
          {
            name: '低风险',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            label: {
              show: true,
              position: 'top',
              fontWeight: 'bold',
            },
            data: this.values.lowRiskCount,
          },
        ],
      }
    },
  },
  props: {
    values: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartLoading: false,
    }
  },
}
</script>

<style lang="scss" scoped></style>
